import { ActionTree } from 'vuex';
import { NotificationsState } from '../stores/notifications.store';
import { RootState } from '../store';
import { mutationSetNotifications, mutationSetError } from '../mutations/notifications.mutations';
import { getNotifications } from '@/services/notifications.service';
import { INotification } from '@/types/Notification';

export const actionGetNotifications = 'getUnreadCount';

export const actions: ActionTree<NotificationsState, RootState> = {
  async [actionGetNotifications]({ commit }) {
    try {
      const { data } = await getNotifications(false);
      const notifications: INotification[] = data.notification.map(n => {
        return {
          companyName: n.company_name,
          createdAt: n.created_at,
          documentId: n.document_id,
          documentName: n.document_name,
          documentStatus: n.document_status,
          eventMetaData: n.event_meta_data,
          eventName: n.event_name,
          firstName: n.first_name,
          gender: n.gender,
          lastName: n.last_name,
          thumbUrl: n.thumb_url,
        };
      });
      commit(mutationSetNotifications, notifications);
    } catch (err) {
      commit(mutationSetError, err);
    }
  },
};
